import {Base} from "@/api/Base"

export class AdvisorOverrideDelete extends Base {
    path = "advisorOverride/delete"
}